import "../scss/main.scss";

import {
    idempotentBabelPolyfill
} from 'idempotent-babel-polyfill';
idempotentBabelPolyfill();

// Vue
import Vue from 'vue';
import axios from "axios";
import VueAxios from "vue-axios";
// register jw pagination component globally
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

Vue.use(VueAxios, axios);

// gsap - https://github.com/greensock/GSAP
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

var fMap = require('./map.js');
var fPostListSingle = require('./post-list-single.js');
var fMainMenu = require('./main-menu.js');
var fHomeHero = require('./home-hero.js');
var fWorkWith = require('./work-with.js');
var fFooter = require('./footer.js');
var fAnimations = require('./animations.js');
var fPopupContact = require('./contact-popup.js');
var fRecruitment = require('./recruitment.js');
var fOurTeam = require('./our-team.js');
var fSubServices = require('./subservices.js');
var fFxcHeadingList = require('./fxc-heading-content-list');

function refreshScripts() {
    gsap.timeline()
        .to('.loading', {
            display: 'none',
            opacity: 0,
            duration: 0.5
        });

    fFooter(gsap);
    fMap();
    fPostListSingle(gsap, SplitText);
    fHomeHero(gsap, SplitText);
    fMainMenu(gsap);
    fAnimations(gsap);
    fPopupContact(gsap, SplitText);
    fWorkWith(Swiper);
    fRecruitment(Swiper);
    fOurTeam(Swiper);
    fSubServices(Swiper);
    fFxcHeadingList(Swiper);


    window.addEventListener('resize', () => {
        if (window.innerWidth > 959) {
            fWorkWith(Swiper);
            fRecruitment(Swiper);
            fOurTeam(Swiper);
            fSubServices(Swiper);
            fFxcHeadingList(Swiper);
        }

    }, true);
}

Vue.component(
    'home-hero',
    require('./vue/home/hero.vue').default
);

Vue.component(
    'blog-posts',
    require('./vue/blog-posts.vue').default
);



if (!$('body').hasClass('page-template-tpl_contact-php')) {
    const app = new Vue({
        el: '#main'
    });
}

$(document).ready(function () {

    refreshScripts();

    // const swiper = new Swiper('.swiper-container', {
    //     slidesPerView: 3,
    //     spaceBetween: 30,
    //     navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //     },
    // });
    /*
    $(document).on('click', 'a:not([target="_blank"], [href^=mailto])', function (e) {
        e.preventDefault();

        let _this = $(this);
        let url = _this.attr('href');
        let newUrl = url.replace(/^.*\/\/[^\/]+/, '');

        if (url.includes('#')) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - $('.main-header').outerHeight() + 1
                    }, 1000);
                }
            }

            return false;
        }

        newUrl = (!newUrl) ? url : newUrl;

        if (window.location.href.replace(/\/$/, "") != url.replace(/\/$/, "")) {

            $.ajax({
                url: url,
                type: "POST",
                datattype: "html",
                success: function (data) {

                    const mainResult = data;

                    // console.log(data);

                    var result = $.parseHTML(data);

                    // $("html").html(result);

                    // $("html").html(result);

                    // $("head").html(mainResult.substring(mainResult.indexOf("<head>") + 16, mainResult.indexOf("</head>")));
                    // console.log(mainResult.indexOf("<body>"));
                    // $("body").html(mainResult.substring(mainResult.indexOf("<body>") + 16, mainResult.indexOf("</body>")));

                    var startHead = data.indexOf("<head>");
                    var endHead = data.indexOf("</head>");

                    var headString = data.substring(startHead+6,endHead);

                    var startBody = data.indexOf("<body>");
                    var endBody = data.indexOf("</body>");
                    var bodyString = data.substring(startBody+6,endBody);

                    // $('head').html(headString);
                    // $('body').html(bodyString);

                    // document.write(data)
                    // refreshScripts();

                    let html = result.find(x => x.id == 'main');
                    let title = result.find(x => x.nodeName == 'TITLE');

                    // console.log(result);

                    // setTimeout(function () {
                    //
                        $(window).scrollTop(0);
                        $('#main').html(html);
                    //
                    //     $("html").html(result);
                    //
                        $(document).ready();
                    //
                    //     // history.pushState({}, null, newUrl);
                        document.title = title.innerHTML
                        refreshScripts();
                    // }, 700);

                },
            });
        } else {

        }
    });

     */
});